export default __webpack_public_path__ + "static/share-image-1cd8dae0cc13ad654e636fc9a6c5e8d1.jpg";